import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { Carousel, Input } from 'antd';
import {
    applyDiscountsToProducts,
    getProductPriceByClient,
    showOneProduct,
    addItemToOrder
} from '../../actions';
import DisplayAmount from '../common/DisplayAmount';
import DisplayIVA from '../common/DisplayIVA';
import DisplayStock from '../common/DisplayStock';
import { getRolename } from '../../lib/AuthUtils'
import { getIvaToCalc } from '../../lib/IVAUtils';
import { getImagesPath, getProductImagePath, checkDealPrice } from '../../lib/CatalogUtils';
const { TextArea } = Input;

class CatalogProductDetail extends Component {

    componentDidMount() {
        const { idProduct } = this.props;
        if (idProduct) {
            this.props.showOneProduct({ codigodearticulo: idProduct });
        }
    }

    infoProduct() {
        const { order, role, product, detail, price } = this.props;
        const { id, codigodearticulo, descripcion, preciolista, tipodeiva, cantidadminima, multiplo } = product;

        this.itemToAdd = {
            id,
            codigodearticulo,
            descripcion,
            precio: preciolista,
            cantidad: 1,
            cantidadminima: cantidadminima,
            multiplo: multiplo,
            tipodeiva: tipodeiva,
            observaciones: ''
        };

        if (role === 'cliente' && !price) {
            this.props.getProductPriceByClient({ codigodearticulo: product.codigodearticulo });
        }

        if (order && order.cliente && order.cliente.codigocliente && !detail.discount) {
            this.props.applyDiscountsToProducts({
                clientCode: order.cliente.codigocliente,
                products: [{ codigodearticulo: product.codigodearticulo, cantidad: 1 }]
            });
        }
    }

    addAction = (record) => {
        const { cantidadminima, multiplo } = record;
        let quantity = 1;
        if (cantidadminima && multiplo && multiplo > 0) {
            quantity = (cantidadminima > multiplo) ? Math.ceil(cantidadminima / multiplo) * multiplo : multiplo;
        } else if (cantidadminima) {
            quantity = cantidadminima;
        }

        this.props.addItemToOrder({
            item: {
                cantidad: quantity,
                ...this.itemToAdd
            }
        });
    }

    onInputChange = (key, value) => {
        this.itemToAdd[key] = value;
    }

    calcPriceVAT(price, iva) {
        const vat = getIvaToCalc(iva);
        if (vat) {
            return price * vat;
        }
        return price;
    }

    render() {
        const { product } = this.props;

        if (product) {
            this.infoProduct();
            const { t, product, role, price, detail } = this.props;
            const dealPrice = checkDealPrice(product);
            const costPrice = detail && detail.discount && detail.discount.precioFinal ? detail.discount.precioFinal : product.preciolista;

            // Add VAT to suggested price if not calculated
            let suggestedPrice;
            if (price) {
                suggestedPrice = this.calcPriceVAT(price.data, product.tipodeiva);
            } else {
                suggestedPrice = this.calcPriceVAT(product.preciolista, product.tipodeiva);
            }

            return (
                <div className='container row mx-auto px-0 py-4'>
                    <div className='col-md-5'>
                        <Carousel>
                            {
                                product.imagesFiles && product.imagesFiles.length > 0 &&
                                product.imagesFiles.map((image, i) => (
                                    <div key={i}><img src={getImagesPath() + image} className={"catalog-item-detail-picture"} /></div>
                                )) || <div key={0}><img src={getProductImagePath(product)} className={"catalog-item-detail-picture"} /></div>
                            }
                        </Carousel>
                    </div>
                    <div className='col-md-6'>
                        <h3 className='h3 mb-0 border-bottom border-secondary py-2'>{product.descripcioncatalogo}</h3>
                        <ul className='list-unstyled py-3 mb-0'>
                            {role === 'cliente' ? <li className='d-table-row'>
                                <div className='d-table-cell text-right pr-2'>{t('suggestedPrice')}:</div>
                                <DisplayAmount
                                    amount={suggestedPrice}
                                    currency={product.moneda_preciolista} />
                            </li> : null}

                            <li className='d-table-row'>
                                <div className='d-table-cell text-right pr-2'>{t('listPrice')}:</div>
                                <DisplayAmount
                                    amount={product.preciolista}
                                    currency={product.moneda_preciolista} />
                            </li>

                            {dealPrice ? <li className='d-table-row'>
                                <div className='d-table-cell text-right pr-2'>{t('dealListPrice')}:</div>
                                <DisplayAmount
                                    amount={dealPrice}
                                    currency={product.moneda_preciooferta} />
                            </li> : null}

                            <li className='d-table-row'>
                                <div className='d-table-cell text-right pr-2'>{t('Cost_s/IVA')}:</div>
                                <DisplayAmount
                                    amount={costPrice}
                                    currency={product.moneda_preciolista} />
                            </li>
                        </ul>
                        <div>
                            <span className='mr-2'>{t('Stock')}:</span>
                            <DisplayStock product={product}/>
                        </div>
                        <div className='mb-3'>
                            <span className='mr-2'>{t('VAT')}:</span>
                            <DisplayIVA iva={product.tipodeiva} />
                        </div>
                        {role !== 'admin' ?
                            <>
                                <div className='mb-3'>
                                    <label>{t('Observations')}</label>
                                    <TextArea rows={3} onChange={(event) => this.onInputChange('observaciones', event.target.value)} />
                                </div>

                                <button type='button' className='btn btn-danger w-100 mb-2' onClick={() => this.addAction(product)}>
                                    {t('Add products to cart')}
                                </button>
                            </> : null}
                        <p>{product.descripcionadicional}</p>
                    </div>
                </div>
            );
        }
        return (
            <h1>Cargando...</h1>
        );
    }
}

function mapStateToProps({ catalog, quotation, products, orders, auth, width }) {
    return {
        product: products.productOne,
        role: getRolename(auth),
        order: orders.current,
        quotation: quotation.current,
        price: products.productPrice,
        detail: catalog.itemDetail
    };
};

export default connect(mapStateToProps, {
    getProductPriceByClient,
    addItemToOrder,
    showOneProduct,
    applyDiscountsToProducts
})(withTranslation()(CatalogProductDetail));
